<template>

    <div class="text-left" style="vertical-align: center">

        <v-dialog
                v-model="dialog"
                width="800"
                @close="this.$emit('rerender')"
        >
            <template v-slot:activator="{ on: dialog }">
                <v-tooltip bottom class="pa-0 ma-0">
                    <template v-slot:activator="{ on: tooltip}">
                        <span v-on="{...tooltip}">
                            <v-btn
                                    class="pa-0 ma-0"
                                    :disabled="buttonIsDisabled"
                                    color="primary"
                                    small
                                    v-on="{...dialog}"
                                    icon
                            >
                                <v-icon>
                                    mdi-swap-horizontal-circle-outline
                                </v-icon>
                            </v-btn>
                        </span>

                    </template>
                    {{$t('ChangeDevice')}}
                </v-tooltip>

            </template>

            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                >
                    {{$t('ChangeDevice')}}
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <span v-if="translatedMode === 2">{{$t('cards.AllFromFilter')}}</span>
                            <span v-else>{{$t('cards.Selected')}}. {{$t('cards.total')}}: {{selectedCards.length}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            {{$t('referenceBooks.devices.Device')}}
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                    :items="availableDevices"
                                    v-model="selectedDevice"

                                    :item-value="'deviceId'"
                                    :item-text="'deviceName'"

                                    :label="$t('cards.AvailDev') + `(${availableDevices.length})`"/>
                        </v-col>
                        <v-col cols="2">

                        </v-col>
                    </v-row>

                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary" dark small @click="dialog = false">{{$t('Close')}}</v-btn>
                    <v-btn :disabled="!deviceIsSelected" color="primary" small @click="sendChanges">
                        {{$t('Save')}}
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>

</template>

<script>
import {notifyError, notifySuccess} from '@/services/notifications';

export default {
  name: 'ManageCardDialog',
  props: {
    selectedCards: {
      type: Array,
      defaultItem: []
    },
    filter: {
      type: Object,
      defaultItem: {}
    },
    mode: {
      type: Number,
      defaultItem: 0
    },
    buttonIsDisabled : Boolean
  },
  computed: {
    deviceIsSelected() {
      return !!this.selectedDevice;
    },
    translatedMode(){
      return this.mode + 1;
    },
  },
  watch: {
    async dialog(val) {
      if (val){
        this.availableDevices = [];
        await this.loadParams();
      } else {
        this.$emit('rerender');
      }
    }
  },
  data() {
    return {
      e1: 1,
      dialog: false,

      availableDevices: [],

      selectedDevice: 0
    };
  },
  methods: {
    async sendChanges() {
      this.e1 = 3;

      this.loading = true;

      const data = this.selectedCards.map(c => c.cardId);
      const params = {
        mode: this.translatedMode,
        query: this.filter,

        deviceId: this.selectedDevice,
        priorityId: this.selectedPriority,
        statusId: this.selectedStatus
      };

      await this.$axios.cards.move(data, params)
        .then(response => {
          if (response.status === 200) {
            notifySuccess('', this.$t('cards.Success'));
            this.dialog = false;
          }
        })
        .catch(error => {
          notifyError('', this.$t('Error'));
          console.error(error);
        });

      this.loading = false;
    },
    async loadParams() {
                
      const data = this.selectedCards.map(c => c.cardId);
      const params = {
        mode: this.translatedMode,
        query: this.filter
      };
      await this.$axios.cards.loadParams(data, params)
        .then(response => response.data)
        .then(json => {
          this.availableDevices = json;
        })
        .catch(e => {
          const {errorType} = e.response.data;
          console.error(e);
          switch (errorType) {
          case 'WRONG_STATUS': {
            notifyError('', this.$t('cards.wrongStatus'));
            break;
          }
          case 'NO_FILTER' : {
            notifyError('', this.$t('cards.noFilter'));
            break;

          }
          default: {
            notifyError('', this.$t('Error'));
            break;
          }

          }
        });

    }
  }
};
</script>
